import { useCurrency } from '@procureai/ui-mui';
import Decimal from 'decimal.js';
import { isNil } from 'ramda';
import { useCallback } from 'react';
import { Union } from 'ts-toolbelt';

interface FormatTotalProps {
  pricePerUnit?: Union.Nullable<number>;
  quantity?: Union.Nullable<number>;
}
export const useTotalLineItemFormat = () => {
  const { format } = useCurrency();

  const getTotal = useCallback(({ pricePerUnit, quantity }: FormatTotalProps) => {
    return isNil(pricePerUnit) || isNil(quantity) ? 0 : new Decimal(pricePerUnit).mul(quantity).toNumber();
  }, []);

  return {
    formatTotal: useCallback((item: FormatTotalProps) => format(getTotal(item)), [format, getTotal]),
    getTotal,
  };
};
